// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag-module__tag___1Yk3n","tagRed":"Tag-module__tagRed___2T8CW"};